<template>
    <div>
        <nav
            role="navigation"
            class="left-nav"
            aria-label="Left Navigation Menu"
        >
            <div class="nav-section-home d-sm-block">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    version="1.1"
                    viewBox="0 0 24 24"
                >
                    <title>home</title>
                    <path
                        d="M9.984 20.016h-4.969v-8.016h-3l9.984-9 9.984 9h-3v8.016h-4.969v-6h-4.031v6z"
                    />
                </svg>
                <brfss-router-link
                    :item="indexItem"
                    title="BRFSS WEAT"
                ></brfss-router-link>
                <!-- <a href="/wcms/4.0/cdc-wp/index.html">BRFSS WEAT</a> -->
            </div>
        </nav>
        <div class="col" :class="displayType">
            <div class="left-nav hidden-print">
                <nav-group :group="actionsGroup"></nav-group>
                <nav-group :group="reportsGroup"></nav-group>
                <nav-group :group="userGuideGroup"></nav-group>
                <nav-group :group="relatedInformationGroup"></nav-group>
            </div>
        </div>
    </div>
</template>
<script>
/* eslint no-unused-vars: 'off', quotes: 'off' */
import { mapGetters, mapState } from 'vuex';
import store from '@/store';
import brfssRouterLink from '@/components/sub/brfssRouterLink';
import navGroup from '@/components/layout/navGroup';
import navMenuItems from '@/scripts/nav/menuItems';

function menuItem(name, url, vuePath) {
    return { name, url, vuePath };
}

export default {
    props: ['displayType'],
    computed: {
        ...mapState({
            menuGroup: (state) => state.display.menuGroup,
            menuItem: (state) => state.display.menuItem,
            actions: (state) => state.security.actions,
            isPublic: (state) => state.security.isPublic
        }),
        ...mapGetters({
            menuGroup: 'display/getMenuGroup',
            menuItem: 'display/getMenuItem'
        })
    },
    components: {
        brfssRouterLink,
        navGroup
    },
    data: function () {
        const menuItems = navMenuItems.menuItems;
        var vmData = {
            menuItems,
            indexItem: navMenuItems.menuItems.byName.analysis,
            actionsGroup: {
                name: 'analysis',
                title: 'Analysis',
                url: this.isPublic ? '/index' : '/analysis',
                menu: filterAuthorized(menuItems.rootMenus.actions),
                isExpanded: true
            },
            reportsGroup: {
                name: 'reports',
                title: 'Reports',
                url: '/reports',
                menu: filterAuthorized(menuItems.rootMenus.reports),
                isExpanded: false
            },
            userGuideGroup: {
                name: 'userGuide',
                title: 'User Guide',
                url: '/userGuide',
                menu: filterAuthorized(menuItems.rootMenus.userGuide),
                isExpanded: false
            },
            relatedInformationGroup: {
                name: 'relatedInformation',
                title: 'Related Information',
                url: null,
                menu: menuItems.rootMenus.relatedInformation,
                isExpanded: false
            }
        };
        return vmData;
    },
    methods: {
        redirectUser(e, to) {
            let vm = this;
            if (e) e.preventDefault();
            store.dispatch('display/clearMessages');
            this.$router.push(to);
            return false;
        },
        isSelectedClass: function (menuItem) {
            return this.menuItem === menuItem ? 'selected' : '';
        },
        isSelectedGroup: function (menuGroup) {
            return this.menuGroup === menuGroup ? 'selected' : '';
        }
        // getActions () {
        //   const vm = this;
        // },
    }
};

function filterAuthorized(menu) {
    return (menu || []).filter((m) => isAuthorizedFor(m.isAuthorizedFor));
}

function isAuthorizedFor(c) {
    if (!c) return true;
    return store.state.security.actions.indexOf(c.toLowerCase()) >= 0;
}

// function filterAuthorized(menu) {
//     let vm = this;
//     return menu.filter(m => vm.isAuthorizedFor(m.isAuthorizedFor));
// }
</script>

<style scoped>
.expand-button a {
    display: inline-block;
}

a {
    margin: 5px;
    margin-right: 0 !important;
    padding-right: 0 !important;
}

.nav-section-home {
    padding: 10px 8px;
    font-family: 'Open Sans', apple-system, blinkmacsystemfont, 'Segoe UI',
        'Helvetica Neue', arial, sans-serif;
    font-size: 13pt;
    font-weight: 400;
    border-bottom: 1px dashed #e0e0e0;
    border-top-width: 0;
    border-top-style: solid;
    border-left: 4px solid #fff;
    transition: background-color 0.4s ease;
    transition: border-left-color 0.4s ease;
}

.nav-section-home,
a.mobile-section-nav-foot {
    color: #fff;
    border-bottom: none;
    border-left: 0;
    text-decoration: none;
}

nav .nav-section-home a {
    text-decoration: none;
}

.nav-section-home a {
    color: #555;
    transition: color 0.4s ease;
    overflow: hidden;
    display: block;
}
nav .nav-section-home svg {
    fill: #4b830d;
    margin-top: 6px;
}

.nav-section-home .fi,
.nav-section-home svg {
    float: left;
}

.nav-section-home svg,
a.mobile-section-nav-foot svg {
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 4px;
    margin-bottom: 2px;
    fill: #fff;
    vertical-align: middle;
}

nav .nav-section-home a {
    text-decoration: none;
}

.nav-section-home a {
    color: #555;
    transition: color 0.4s ease;
    overflow: hidden;
    display: block;
}
</style>
<style>
/*-------------------------------------------------------------------------*/

.left-nav {
    font-family: 'Open Sans', apple-system, BlinkMacSystemFont, 'Segoe UI',
        'Helvetica Neue', Arial, sans-serif;
    font-size: 17px;
    font-weight: normal;
    background-color: #fff;
}

.left-nav h3 {
    margin: 0;
    background-color: #f5f5f5;
}

.left-nav h3 a {
    /* color: #555;
    transition: color .4s ease;
    overflow: hidden;
    display: block; */
    font-size: 13pt;
    text-decoration: none;
    color: #333;
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    padding-left: 0.25rem;
    margin-bottom: 0;
    border-bottom: 1px dashed #e0e0e0;
    position: relative;
    transition: border-color 0.5s, background-color 0.5s, color 0.5s;
}

.left-nav h3 svg {
    fill: #4b830d;
    display: inline-block;
    width: 24px;
    height: 24px;
    margin-right: 4px;
    margin-bottom: 2px;
    fill: #4b830d;
    vertical-align: middle;
    overflow: hidden;
}

.left-nav > h3 > a:last-child {
    position: absolute;
    z-index: 998;
    top: 15px;
    right: 5px;
    width: 20px;
    height: 20px;
    display: inline-block;
    padding: 0;
    background-color: transparent;
    border: none;
    box-sizing: content-box;
    text-align: center;
    text-decoration: none;
    color: #333;
    margin-bottom: 0;
    margin-right: 14px;
    transition: border-color 0.5s, background-color 0.5s, color 0.5s;
    font-family: 'Open Sans', apple-system, BlinkMacSystemFont, 'Segoe UI',
        'Helvetica Neue', Arial, sans-serif;
    font-weight: 400;
    line-height: 1.5;
}

.left-nav h3 a:last-child:link svg,
.left-nav h3 a:last-child:visited svg {
    padding: 0;
    fill: #bdbdbd;
    width: 100%;
    height: 100%;
    transition: fill 0.5s, transform 0.4s linear;
    transform: rotate(0deg);
    color: #333;
    cursor: pointer;
}
.left-nav h3 a:last-child:link.nav-plus svg,
.left-nav h3 a:last-child:visited.nav-plus svg {
    transform: rotate(90deg) !important;
}

.left-nav > div {
    margin: 0;
    padding: 0;
    position: relative;
}

/* nav ul.tp-nav-main li a:link,
nav ul.tp-nav-main li a:visited,
nav ul.tp-nav-main li a:hover,
nav ul.tp-nav-main li a:active,
nav ul.tp-nav-main li ul li a:link,
nav ul.tp-nav-main li ul li a:visited,
nav ul.tp-nav-main li ul li a:hover,
nav ul.tp-nav-main li ul li a:active,
nav .mobile-section-nav li a:link,
nav .mobile-section-nav li a:visited,
nav .mobile-section-nav li a:hover,
nav .mobile-section-nav li a:active,
nav .mobile-section-nav li ul li a:link,
nav .mobile-section-nav li ul li a:visited,
nav .mobile-section-nav li ul li a:hover,
nav .mobile-section-nav li ul li a:active  */

.left-nav > div.active > .h4 {
    border-left: 4px solid #4b830d;
}

.left-nav > div > .h4 {
    margin-top: 0px;
    font-size: 17px;
    text-decoration: none;
    color: #333;
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    border-bottom: 1px dashed #e0e0e0;
    transition: border-color 0.5s, background-color 0.5s, color 0.5s;
    border-left: 4px solid #fff;
    line-height: 1.5;
}

.left-nav > div > div:not(.h4) > a:link,
.left-nav > div > div:not(.h4) > a:visited,
.left-nav > div > div:not(.h4) > a:hover,
.left-nav > div > div:not(.h4) > a:active {
    margin-top: 0px;
    font-size: 17px;
    text-decoration: none;
    color: #333;
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    transition: border-color 0.5s, background-color 0.5s, color 0.5s;
}

.left-nav > div:hover > .h4 {
    background-color: #f5f5f5;
    color: #007c91;
    border-left: 4px solid #4b830d;
}
a.group-link {
    text-decoration: none;
    text-decorationcolor: #333;
    color: #333;
}
.left-nav > div > .h4 > a:not(.group-link) {
    position: absolute;
    z-index: 998;
    top: 15px;
    right: 5px;
    width: 20px;
    height: 20px;
    display: inline-block;
    padding: 0;
    background-color: transparent;
    border: none;
    box-sizing: content-box;
    text-align: center;
    text-decoration: none;
    color: #333;
    margin-bottom: 0;
    transition: border-color 0.5s, background-color 0.5s, color 0.5s;
    font-family: 'Open Sans', apple-system, BlinkMacSystemFont, 'Segoe UI',
        'Helvetica Neue', Arial, sans-serif;
    font-weight: 400;
    line-height: 1.5;
}

.left-nav > div .h4 a.nav-plus:link svg,
.left-nav > div .h4 a.nav-minus:link svg,
.left-nav > div .h4 a.nav-plus:visited svg,
.left-nav > div .h4 a.nav-minus:visited svg {
    padding: 0;
    fill: #bdbdbd;
    width: 100%;
    height: 100%;
    transition: fill 0.5s, transform 0.4s linear;
    transform: rotate(0deg);
    color: #333;
    cursor: pointer;
}

.left-nav > div .h4 a.nav-plus.nav-plus svg,
.left-nav > div .h4 a.nav-minus.nav-plus svg {
    transform: rotate(-90deg) !important;
}

.left-nav > div > div:not(.h4) > a.active,
.left-nav > div > div:not(.h4) > a.active:not([href]):not([tabindex]) {
    border-left: 4px solid #84bc49;
}

.left-nav > div > div:not(.h4) > a:hover {
    background-color: #f5f5f5;
    color: #84bc49;
    border-left: 4px solid #84bc49;
}

.left-nav > div > .h4 {
    cursor: pointer;
}

.left-nav > div > div:not(.h4) > a {
    display: block;
    border: none;
    border-left: 4px solid #f5f5f5;
    margin: 0;
    padding: 0;
    position: relative;
    cursor: pointer;
    text-decoration: none;
    color: #333;
    position: relative;
    display: block;
    padding: 0.75rem 1.25rem;
    margin-bottom: 0;
    border-bottom: 1px dashed #e0e0e0;
    position: relative;
    transition: border-color 0.5s, background-color 0.5s, color 0.5s;
    margin-left: 20px;
}

.left-nav > div > div:not(.h4) > a:not([href]):not([tabindex]) {
    color: #333;
    text-decoration: none;
}
</style>
